import { useCallback } from "react";
import * as Actions from "../actions";
import { useDomainUseCase } from "./useDomainUseCase";

export const usePubnubCredentialsDomainActions = () => {
  const { execute } = useDomainUseCase();

  const getPubnubCredentials = useCallback(() => {
    execute({
      useCase: "GetPubnubCredentialsUseCase",
      params: {},
      getLoadingAction: Actions.getPubnubCredentials.bind(Actions),
      getErrorAction: Actions.getPubnubCredentialsError,
      getSuccessAction: Actions.getPubnubCredentialsSuccess,
    });
  }, []);

  return {
    getPubnubCredentials,
  };
};
